import { render } from "./Header.vue?vue&type=template&id=4af18ef7"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4af18ef7&lang=scss"

import exportComponent from "/home/dvu/src/d20app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__